import _ from 'lodash';
import { useMediaQuery } from 'react-responsive';
import theme from '../../../../assets/stylesheets/_settings.global.scss';
import Investor from '../investor';
import Interests from '../interests';
import Holdings from '../holdings';

export default function commonProps() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const isMobile = useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` });
  const profile = _.get(window, 'Livewire.currentUser.profile');
  const isUserSignedIn = !!(_.get(profile, 'firstName'));
  const steps = [
    { name: 'investor', comp: Investor },
    { name: 'interests', comp: Interests },
    { name: 'follow', comp: Holdings },
  ];

  return {
    ...theme,
    isMobile,
    isUserSignedIn,
    steps,
  };
}
